// App.js
import React from 'react';
import ProductSearch from './components/ProductSearch';

function App() {
  return (
    <div>
      <ProductSearch />
    </div>
  );
}

export default App;
